import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

/**
 * Vue ADMIN d'un fournisseur. `hasClientSecret` remplace le secret lui-même :
 * l'API ne le renvoie jamais, l'écran affiche seulement s'il est enregistré.
 */
const ssoProviderFields = {
  id: true,
  kind: true,
  protocol: true,
  label: true,
  enabled: true,
  issuer: true,
  clientId: true,
  hasClientSecret: true,
  entryPoint: true,
  idpIssuer: true,
  idpCert: true,
  allowedDomains: true,
  requiresAllowedDomains: true,
  callbackUrl: true,
  metadataUrl: true,
} as const

/** Interrupteur général du SSO de l'organisation, au-dessus des fournisseurs. */
export const GQL_SSO_SETTINGS = typedGql('query', { scalars })({
  ssoSettings: { enabled: true },
})

export const GQL_SET_SSO_ENABLED = typedGql('mutation', { scalars })({
  setSsoEnabled: [
    { enabled: $('enabled', 'Boolean!') },
    { enabled: true },
  ],
})

export const GQL_SSO_PRESETS = typedGql('query', { scalars })({
  ssoPresets: {
    kind: true,
    protocol: true,
    defaultLabel: true,
    defaultIssuer: true,
    issuerHint: true,
    sharedIssuer: true,
  },
})

export const GQL_SSO_PROVIDER_CONFIGS = typedGql('query', { scalars })({
  ssoProviderConfigs: ssoProviderFields,
})

export const GQL_UPSERT_SSO_PROVIDER = typedGql('mutation', { scalars })({
  upsertSsoProvider: [
    { input: $('input', 'UpsertSsoProviderInput!') },
    ssoProviderFields,
  ],
})

export const GQL_DELETE_SSO_PROVIDER = typedGql('mutation', { scalars })({
  deleteSsoProvider: [
    { kind: $('kind', 'SsoProviderKind!') },
    true,
  ],
})

/** Requête publique de l'écran de connexion : un bouton, une URL. */
export const GQL_SSO_PROVIDERS = typedGql('query', { scalars })({
  ssoProviders: {
    id: true,
    kind: true,
    label: true,
    loginUrl: true,
  },
})
